import { SagaIterator } from "@redux-saga/types";
import { call, put } from "redux-saga/effects";
import { ProfileRedux } from "../redux/profile-redux/ProfileRedux";
import { setError } from "../redux/toaster-redux/ToasterRedux";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";

export function* getProfileDetailsByIdSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(api.getProfileDetailsById, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.getProfileDetailsByIdSuccess(response.data)
      );
    } else {
      yield put(
        ProfileRedux.actions.getProfileDetailsByIdFailure(response.data)
      );
    }
  } catch (error) {
    yield put(ProfileRedux.actions.getProfileDetailsByIdFailure(error));
  }
}

export function* followOrUnFollowUserSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.followUser, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.followOrUnFollowUserSuccess(response.data)
      );
    } else {
      yield put(
        ProfileRedux.actions.followOrUnFollowUserFailure(response.data)
      );
    }
  } catch (error) {
    yield put(ProfileRedux.actions.followOrUnFollowUserFailure(error));
  }
}

export function* getAllFollowingSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllFollowing, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(ProfileRedux.actions.getAllFollowingSuccess(response.data));
    } else {
      yield put(ProfileRedux.actions.getAllFollowingFailure(response.data));
    }
  } catch (error) {
    yield put(ProfileRedux.actions.getAllFollowingFailure(error));
  }
}

export function* getAllFollowersSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllFollowers, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(ProfileRedux.actions.getAllFollowerSuccess(response.data));
    } else {
      yield put(ProfileRedux.actions.getAllFollowerFailure(response.data));
    }
  } catch (error) {
    yield put(ProfileRedux.actions.getAllFollowerFailure(error));
  }
}

export function* getAllShareUsersSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllShareUsers, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(ProfileRedux.actions.getAllShareSuccess(response.data));
    } else {
      yield put(ProfileRedux.actions.getAllShareFailure(response.data));
    }
  } catch (error) {
    yield put(ProfileRedux.actions.getAllShareFailure(error));
  }
}

export function* getAllMutualsSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllMutuals, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(ProfileRedux.actions.getAllMutualSuccess(response.data));
    } else {
      yield put(ProfileRedux.actions.getAllMutualFailure(response.data));
    }
  } catch (error) {
    yield put(ProfileRedux.actions.getAllMutualFailure(error));
  }
}

export function* updateProfileDetailsSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.updateProfileDetails, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.updateProfileDetailsSuccess(response.data)
      );
      // yield put(setSuccessfull(response));
    } else {
      yield put(
        ProfileRedux.actions.updateProfileDetailsFailure(response.data)
      );
      yield put(setError(response));
    }
  } catch (error) {
    yield put(ProfileRedux.actions.updateProfileDetailsFailure(error));
  }
}

// search following and followers --start--
export function* searchUserInFollowingListSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(api.searchUserInFollowingList, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.searchUserInFollowingListSuccess(response)
      );
    } else {
      yield put(
        ProfileRedux.actions.searchUserInFollowingListFailure(response)
      );
    }
  } catch (error) {
    yield put(ProfileRedux.actions.searchUserInFollowingListFailure(error));
  }
}

export function* searchUserInFollowersListSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(api.searchUserInFollowersList, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.searchUserInFollowersListSuccess(response)
      );
    } else {
      yield put(
        ProfileRedux.actions.searchUserInFollowersListFailure(response)
      );
    }
  } catch (error) {
    yield put(ProfileRedux.actions.searchUserInFollowersListFailure(error));
  }
}

export function* searchUserInShareListSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(api.searchProfilesInExplore, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.searchUserInShareListSuccess(response)
      );
    } else {
      yield put(
        ProfileRedux.actions.searchUserInShareListFailure(response)
      );
    }
  } catch (error) {
    yield put(ProfileRedux.actions.searchUserInShareListFailure(error));
  }
}

export function* getAllSavedPostSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllSavedPost, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(ProfileRedux.actions.getAllSavedPostSuccess(response.data));
    } else {
      yield put(ProfileRedux.actions.getAllSavedPostFailure(response.data));
    }
  } catch (error) {
    yield put(ProfileRedux.actions.getAllSavedPostFailure(error));
  }
}

export function* saveOUnsavePostToFavouriteSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(
      api.saveOrUnsavePostToFavourite,
      action.payload
    );
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.saveOrUnsavePostToFavouriteSuccess(response.data)
      );
      // yield put(setSuccessfull(response));
    } else {
      yield put(
        ProfileRedux.actions.saveOrUnsavePostToFavouriteFailure(response.data)
      );
      yield put(setError(response));
    }
  } catch (error: any) {
    yield put(ProfileRedux.actions.saveOrUnsavePostToFavouriteFailure(error));
    yield put(setError(error));
  }
}

// get Liked Post
export function* getLikedPostSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getLikedPost, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(ProfileRedux.actions.getLikedPostSuccess(response.data));
    } else {
      yield put(ProfileRedux.actions.getLikedPostFailure(response.data));
    }
  } catch (error) {
    yield put(ProfileRedux.actions.getLikedPostFailure(error));
  }
}

// get Liked Post
export function* getPostViewsSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getPostViews, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(ProfileRedux.actions.getPostViewSuccess(response.data));
    } else {
      yield put(ProfileRedux.actions.getPostViewFailure(response.data));
    }
  } catch (error) {
    yield put(ProfileRedux.actions.getPostViewFailure(error));
  }
}

// like Post
export function* likeOrUnlikePostApiSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.likeOrUnlikePost, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(ProfileRedux.actions.likeOrUnlikePostSuccess(response.data));
      // yield put(setSuccessfull(response));
    } else {
      yield put(ProfileRedux.actions.likeOrUnlikePostFailure(response.data));
      yield put(setError(response));
    }
  } catch (error: any) {
    yield put(ProfileRedux.actions.likeOrUnlikePostFailure(error));
    yield put(setError(error));
  }
}

// get Search List In Like
export function* searchUserInLikeListsSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(api.searchUserInLikeLists, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.searchUserInLikeListsSuccess(response.data)
      );
    } else {
      yield put(
        ProfileRedux.actions.searchUserInLikeListsFailure(response.data)
      );
    }
  } catch (error) {
    yield put(ProfileRedux.actions.searchUserInLikeListsFailure(error));
  }
}

export function* uploadProfilePicturesToBackendSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(
      api.uploadProffilePicturesToBackend,
      action.payload
    );
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        ProfileRedux.actions.uploadProfilePictureToBackendSuccess(response.data)
      );
      // yield put(setSuccessfull(response));
    } else {
      yield put(
        ProfileRedux.actions.uploadProfilePictureToBackendFailure(response.data)
      );
      yield put(setError(response));
    }
  } catch (error: any) {
    yield put(ProfileRedux.actions.uploadProfilePictureToBackendFailure(error));
    yield put(setError(error));
  }
}

export function* deleteProfilePictureSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.deleteProfilePicture, action?.payload);
    if (response?.status === HttpResponseTypeEnum.Success) {
      yield put(
        ProfileRedux.actions.deleteProfilePicturesSuccess(response?.data)
      );
      // yield put(setSuccessfull(response));
    } else {
      yield put(
        ProfileRedux.actions.deleteProfilePicturesFailure(response?.data)
      );
      yield put(setError(response));
    }
  } catch (error: any) {
    yield put(ProfileRedux.actions.deleteProfilePicturesFailure(error));
    yield put(setError(error));
  }
}
